// extracted by mini-css-extract-plugin
module.exports = {"container":"AssetListCellBody_container__2ijGa","checkbox":"AssetListCellBody_checkbox__14FJH","id":"AssetListCellBody_id__3wKAC"};